module.exports = __webpack_public_path__ + "static/media/8.f2bbae3c.jpg";